import React from 'react';
import { useNavigate } from 'react-router-dom';
import './CTABanner.css';

function CTABanner({
  heading = 'Ready to Transform Your Carpets?',
  description = 'Speak to our team today for a free, no-obligation quote tailored to your business.',
  ctaText = 'Request Your Free Quote',
  ctaLink = '/contact',
  variant = 'primary',
}) {
  const navigate = useNavigate();

  return (
    <section className={`cta-banner cta-banner--${variant}`}>
      <div className="cta-banner__inner container">
        <div className="cta-banner__text">
          <h2 className="cta-banner__heading">{heading}</h2>
          <p className="cta-banner__desc">{description}</p>
        </div>
        <div className="cta-banner__actions">
          <button
            className={`btn btn--lg ${variant === 'primary' ? 'btn--light' : 'btn--primary'}`}
            onClick={() => navigate(ctaLink)}
          >
            {ctaText}
          </button>
          <a href="tel:+447887394404" className="cta-banner__phone">
            or call 07887 394404
          </a>
        </div>
      </div>
    </section>
  );
}

export default CTABanner;
